module.exports = __webpack_public_path__ + "static/media/CardSki2.f4ef7aaa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/public/registeration/CardSki2.svg
// module id = 117
// module chunks = 0